// extracted by mini-css-extract-plugin
export default {"insights":"insights_insights__0dX66","loadMore":"insights_loadMore__LAjPb","arrow":"insights_arrow__MeKdV"};